import { SortOrder } from "@sonder/ui/source/styled/fragments/Table";
import { SortAscDesc } from "typings/globalGQLTypes";

export const mapGQLSortToSortOrder = (sort?: SortAscDesc | null): SortOrder => {
  if (sort === SortAscDesc.asc) return "asc";
  if (sort === SortAscDesc.desc) return "desc";
  return null;
};
